import { render, staticRenderFns } from "./ColorIndicationDialog.vue?vue&type=template&id=60016481&scoped=true&"
import script from "./ColorIndicationDialog.vue?vue&type=script&lang=js&"
export * from "./ColorIndicationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicationDialog.vue?vue&type=style&index=0&id=60016481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60016481",
  null
  
)

export default component.exports